/**
 * Browser shim for style-to-object
 *
 * CopilotKit dependencies (via react-markdown) use style-to-object
 * which has ESM/CJS compatibility issues with different versions.
 * This shim provides a working implementation for the browser.
 *
 * Converts CSS style strings to JavaScript objects:
 * "color: red; font-size: 16px" → { color: "red", fontSize: "16px" }
 */

// Convert kebab-case to camelCase
function camelCase(property: string): string {
  return property.replace(/-([a-z])/g, (_match, letter) => letter.toUpperCase());
}

// Parse a CSS style string into an object
function styleToObject(style: string | null | undefined): Record<string, string> | null {
  if (!style || typeof style !== 'string') {
    return null;
  }

  const result: Record<string, string> = {};

  // Split by semicolons and process each declaration
  const declarations = style.split(';');

  for (const declaration of declarations) {
    const trimmed = declaration.trim();
    if (!trimmed) continue;

    // Find the first colon (property:value)
    const colonIndex = trimmed.indexOf(':');
    if (colonIndex === -1) continue;

    const property = trimmed.slice(0, colonIndex).trim();
    const value = trimmed.slice(colonIndex + 1).trim();

    if (property && value) {
      // Convert CSS property name to camelCase for React
      const camelProperty = camelCase(property);
      result[camelProperty] = value;
    }
  }

  return Object.keys(result).length > 0 ? result : null;
}

// Export both as default and named export for compatibility
export default styleToObject;
export { styleToObject };
